import { observable, action, computed } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { getRandomColor, splitStrNumber  } from "app/vendor/util"
import { message } from "antd"

const SINGLE_RELATION_NAME = [
  "男方",
  "男方父亲",
  "男方母亲",
  "女方",
  "女方母亲",
  "女方父亲",
]
export default class {
  @observable familyId = "" // 直接写 id 可能会好些
  @observable tableData = []
  @observable sampleData = {}
  @observable historyTableData = []
  @observable selectedRowKeys = []
  @observable totalPrimers = []
  @observable totalGenes = []
  @observable totalMutations = []
  @observable relations = []
  @observable familyInfo = {}
  @observable appInfo = null
  @observable editHistoryList = []
  @observable samplesData = []
  @observable edited = false
  @observable structureMut = [{
    type: 'null',
    name: '',
    breakpoint: '',
    chromosome: '',
    startPosition: '',
    endPosition: '',
    chromosome2: ''
  }]
    @observable delRange = [{
    gender: 'null',
    chromosome: '',
    startPosition: '',
    endPosition: '',
  }]
  singleRelations = []

  @action loadFamilyInfo = () => {
    return request
      .get(`${config.backend}/pgd/family/${this.familyId}`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.familyInfo = res
      })
  }

  @action setFamilyId = (id) => {
    this.familyId = id
  }

  @action getSamplesRefrenceData = () => {
    return request
      .get(`${config.backend}/pgd/datas/samples/${this.familyId}`)
      .checkToken()
      .commonDispose()
      .then(
        (res) => {
          this.samplesData = res
        },
        (err) => {
          message.error(err.message)
        }
      )
  }

  @action syncSampleInfo = () => {
    return request
      .put(`${config.backend}/pgd/datas/samples/${this.familyId}`)
      .checkToken()
      .commonDispose()
  }

  @action initTableData = () => {
    return request
      .get(`${config.backend}/pgd/family/${this.familyId}/datas`)
      .checkToken()
      .commonDispose()
      .then((result) => {
        result.pgdDataDTOs && result.pgdDataDTOs.forEach(sample => {
          sample.hasName = sample.sampleName
          sample.sampleName = sample.sampleName // 手动生成字段
          sample.relationName = sample.relationName
          sample.pathogen = sample.pathogen
          sample.remark = sample.remark
          sample.hasRemark = sample.remark
          sample.patientName = sample.patientName
          sample.hasPatientName = sample.patientName
          sample.marked = false
          sample.mutationType = sample.mutationType
          sample.name = sample.name
          sample.sampleType = sample.sampleType
        })
        result.maleMutation = result.maleMutation
        result.femaleMutation = result.femaleMutation
        this.sampleData = result
       
        if (result.structureMut && result.structureMut.length > 0) {
          this.structureMut=result.structureMut
        }
         if (result.delRange && result.delRange.length > 0) {
          this.delRange=result.delRange
        }
        if (result.genes && result.genes.length > 0) {
          this.loadMutations(result.genes)
        }
      
      })
  }

  @action loadPrimers = () => {
    return request
      .get(`${config.backend}/pgd/primers`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.totalPrimers = res
      })
  }

  @action loadGenes = () => {
    return request
      .get(`${config.backend}/pgd/genes`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.totalGenes = res
      })
  }

  @action loadMutations = (mutations) => {
    mutations = JSON.stringify(mutations)
    return request
      .get(`${config.backend}/pgd/genes/mutations?body=${mutations}`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.totalMutations = res
      })
  }

  @action loadRelations = () => {
    return request
      .get(`${config.backend}/pgd/relations`)
      .checkToken()
      .commonDispose()
      .then((result) => {
        this.setRelationColor(result)
        this.relations = result
        this.singleRelations = result.filter(
          (relation) => SINGLE_RELATION_NAME.indexOf(relation.name) > -1
        )
        this.completeRelations() // 加颜色
        this.updateRelationStatus()
      })
  }

  @action setRelationColor = (arr) => {
    arr.forEach((relation) => (relation.color = getRandomColor()))
  }

  @action onSampleNameChange = (value, sample) => {
    sample.sampleName = value
    this.edited = true
  }

  @action onInputChange = (value, sample, field) => {
    sample[field] = value
    this.edited = true
  }

  @action onInputChangePatientName = (value, sample, field) => {
    this.sampleData.pgdDataDTOs.forEach((item) => {
      if (item.relationId === sample.relationId) {
        item[field] = value
      }
    })
    this.edited = true
  }

  @action onGeneSelect = (gene, sample) => {
    sample.genes.push(gene)
    const mutations = sample.genes.slice()
    this.sampleData.forEach((item) => (item.genes = sample.genes))
    this.loadMutations(mutations)
  }

  @action onGeneDeselect = (gene, sample) => {
    const primerIndex = sample.genes.findIndex((item) => item === gene)
    sample.genes.splice(primerIndex, 1)
    const mutations = sample.genes.slice()
    this.sampleData.forEach((item) => (item.genes = sample.genes))
    if (mutations.length > 0) {
      this.loadMutations(mutations)
    }
  }

  @action onMutationsSelect =  (field, mutation) => {
    if (this.sampleData.pgdDataDTOs) {
      this.sampleData[field] = mutation
      this.edited = true
    }
  }

  @action onMutationsDeselect = (mutation, sample) => {
    const mutationIndex = sample.mutations.findIndex(
      (item) => item === mutation
    )
    sample.mutations.splice(mutationIndex, 1)

    this.sampleData.forEach((item) => {
      if (item.relationId === sample.relationId) {
        item.mutations = sample.mutations
      }
    })
  }

  /* 因为 select 组件中初始值为数组时必须为 group of ids，
   * 而每一个 primer 又没有唯一的 id，因此选择直接拿它本身做显示值
   * 和 key
   */
  @action onPrimerSelect = (primers) => {
    if (this.sampleData.pgdDataDTOs) {
      this.sampleData.primers = primers
      this.usePrimersGetGenes(JSON.stringify(this.sampleData.primers))
      this.edited = true
    }
  }

  @action onPrimerDeselect = (primer, sample) => {
    const primerIndex = sample.primers.findIndex((item) => item === primer)
    sample.primers.splice(primerIndex, 1)
    this.sampleData.forEach((item) => (item.primers = sample.primers))
    this.usePrimersGetGenes(JSON.stringify(sample.primers))
    this.edited = true
  }

  @action usePrimersGetGenes = (params) => {
    return request
    .get(`${config.backend}/pgd/primers/genes?body=${params}`)
    .checkToken()
    .commonDispose()
    .then(res => {
      this.sampleData.genes = res
    })
  }
  @action onGenesSelect = (genes) => {
    if (this.sampleData.pgdDataDTOs) {
      this.sampleData.genes = genes
      this.edited = true
    }
  }

  @action onRelationChange = (relationId, sample) => {
    const relation = this.relations.find(relation => relation.id === relationId)

    sample.relationId = relation.id
    sample.relationName = relation.name
    sample.color = relation.color

    this.disposePathogen(sample)
    this.dispose_name(sample)
    this.dispose_sample_type(sample)
    this.dispose_mutation_type(sample)

    if (!this.singleRelations.find(relation => relation.id === relationId)) {
      this.addNewRelation(relation)
    }

    this.updateRelationStatus()
    this.edited = true
  }
  @action dispose_name = (sample) => {
    let name
    const same_dispose_name_list = this.sampleData.pgdDataDTOs.filter((item) => {
      return item.relationId === sample.relationId && item.id !== sample.id
    })
    same_dispose_name_list.some((item) => {
      if (item.name) {
        name = item.name
        return true
      }
      return false
    })
    if (name) sample.name = name
  }
  @action dispose_sample_type = (sample) => {
    let sample_type
    const same_sample_type_list = this.sampleData.pgdDataDTOs.filter((item) => {
      return item.relationId === sample.relationId && item.id !== sample.id
    })

    same_sample_type_list.some((item) => {
      if (item.sampleType) {
        sample_type = item.sampleType
        return true
      }
      return false
    })
    if (sample_type) sample.sampleType = sample_type
  }

  @action dispose_mutation_type = (sample) => {
    let mutation_type
    const same_mutation_type_list = this.sampleData.pgdDataDTOs.filter((item) => {
      return item.relationId === sample.relationId && item.id !== sample.id
    })
    same_mutation_type_list.some((item) => {
      if (item.mutationType) {
        mutation_type = item.mutationType
        return true
      }
      return false
    })
    if (mutation_type) sample.mutationType = mutation_type
  }

  @action disposePathogen = (sample) => {
    let pathogen
    const sameRelationList = this.sampleData.pgdDataDTOs.filter((item) => {
      return item.relationId === sample.relationId && item.id !== sample.id
    })
    
    sameRelationList.some((item) => {
      if (item.pathogen) {
        pathogen = item.pathogen
        return true
      }
      return false
    })
    if (pathogen) {
      sample.pathogen = pathogen
      return
    }
   
    if(/^(子代)/.test(sample.relationName) || /^(流产组织)/.test(sample.relationName) ||
     /^(儿子)/.test(sample.relationName) || /^(女儿)/.test(sample.relationName)){
      sample.pathogen="p0,m0"
    }else{ 
      sample.pathogen=""
    }
  }

  @action disposeMutation = (sample) => {
    let mutation
    const sameRelationList = this.sampleData.filter((item) => {
      return item.relationId === sample.relationId && item.id !== sample.id
    })
    sameRelationList.some((item) => {
      if (item.mutations) {
        mutation = item.mutations
        return true
      }
      return false
    })
    if (mutation) {
      sample.mutations = mutation
      return
    }
    sample.mutations = []
  }

  @action onPathogenChange = (key, sample) => {
    this.sampleData.pgdDataDTOs.forEach((item) => {
      if (item.relationId === sample.relationId) {
        item.pathogen = key
      }
    })

    this.edited = true
  }

  /**
   * 遍历列表数据选中的relationId，如果出现次数多余两次，增加marked字段为true。
   * 视图里通过判断marked字段，渲染颜色小球
   */
  @action updateRelationStatus() {
    const tempMap = {}
    if (this.sampleData.pgdDataDTOs) {
      this.sampleData.pgdDataDTOs.forEach(sample => {
        tempMap[sample.relationId] = tempMap[sample.relationId] ? tempMap[sample.relationId] + 1 : 1
      })
      this.sampleData.pgdDataDTOs.forEach(sample => {
        sample.marked = tempMap[sample.relationId] > 1
      })
    }
  }

  @action updateTableData = () => {
    this.sampleData.pgdDataDTOs.forEach((sample) => {
      sample.hasName = sample.sampleName
      sample.hasRemark = sample.remark
      sample.hasPatientName = sample.patientName  
    })
  }

  /**
   * 没选关系不处理
   * 选了关系
   * 1. 选了关系 是基本关系里的 就给他加关系的颜色
   * 2. 选了关系 不是基本关系里的 给他加新颜色
   *   1. 如果
   */
  @action completeRelations = () => {
    this.sampleData.pgdDataDTOs && this.sampleData.pgdDataDTOs.forEach(sample => {
      const relation = this.relations.find(relation => relation.id === sample.relationId)

      if (relation) {
        sample.color = relation.color
      } else {
        if (sample.relationId) {
          const newColor = getRandomColor()
          sample.color = newColor
          const position = this.getCompletePosition(sample.relationName)
          const newRelation = {
            id: sample.relationId,
            name: sample.relationName,
            color: newColor
          }
          this.relations.splice(position, 0, newRelation)

          const bundle = splitStrNumber(newRelation.name)
          const newName = bundle.string + (bundle.number + 1)
          if (!this.sampleData.pgdDataDTOs.find(sample => sample.relationName === newName)) {
            this.addNewRelation(newRelation) // newRelation 被插入后，会被 observable 化，此时 newRelation 不再持有数组堆内存
          }
        }
      }
    })
  }

  /*
   * 我们需要根据一定规律插入到对应的位置
   * 只需要正向遍历即可
   */
  getCompletePosition = (relationName) => {
    const bundle = splitStrNumber(relationName)

    for (let i = this.relations.length - 1; i >= 0; i--) {
      const currentBundle = splitStrNumber(this.relations[i].name)
      if (
        bundle.string === currentBundle.string &&
        bundle.number > currentBundle.number
      ) {
        return i + 1
      }
    }
  }

  @action addNewRelation = (relation) => {
    const aimIndex = this.relations.findIndex(item => item.name === relation.name) + 1

    const bundle = splitStrNumber(relation.name)
    const newName = bundle.string + (bundle.number + 1)
    if (!this.relations.find(relation => relation.name === newName)) {
      this.relations.splice(aimIndex, 0, {
        gender: relation.gender,
        id: relation.id + aimIndex,
        name: newName,
        color: getRandomColor()
      })
    }
  }

  @action getHistoryTableData = () => {
    return request
      .get(`${config.backend}/pgd/family/${this.familyId}/tasks`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.historyTableData = res
      })
  }

  @action getTaskDatas = (taskId) => {
    return request
      .get(
        `${config.backend}/pgd/family/${this.familyId}/tasks/${taskId}/datas`
      )
      .checkToken()
      .commonDispose()
  }

  @action setTaskDatas = (id, data) => {
    const rowIndexInCard = this.historyTableData.findIndex(
      (item) => item.id === id
    )
    this.historyTableData[rowIndexInCard].datas = data
  }

  @action clearTaskDetail = () => {
    this.taskDetail = []
  }

  /*
   * 按照 relationId 对 sampleData 进行分组
   */
  @computed get composedData() {
    this.sampleData.pgdDataDTOs.forEach((data) => data.relationName) 
    // 为了使 computed 响应 relationName 的变化, relationId 为什么不行？

    const result = {}
    this.selectedData.forEach((sample) => {
      if (result[sample.relationId]) {
        result[sample.relationId].push(sample)
      } else {
        result[sample.relationId] = [sample]
      }
    })

    return result
  }

  @computed get selectedData() {
    return this.sampleData.pgdDataDTOs.filter((item) =>
      this.selectedRowKeys.includes(item.id)
    )
  }

  @computed get runReady() {
    return (
      this.selectedRowKeys.length > 0 &&
      !this.selectedData.some(
        (sample) =>
          !sample.primers.length || !sample.relationName || !sample.pathogen
      )
    )
  }

  @computed get saveReady() {
    return this.edited
  }

  @action deleteData = (sampleId) => {
    const index = this.sampleData.findIndex((data) => data.id === sampleId)
    this.sampleData.splice(index, 1)
  }

  @action getAppInfo = () => {
    return request
      .get(`${config.backend}/pgd/apps/${this.familyInfo.appId}`)
      .checkToken()
      .commonDispose()
      .then((res) => (this.appInfo = res))
  }

  @action clearAppInfo = () => {
    this.appInfo = null
  }

  @action saveDatas = () => {
    this.sampleData.structureMut=this.structureMut
    this.sampleData.delRange=this.delRange
    return request
      .put(`${config.backend}/pgd/family/${this.familyId}/datas`)
      .send(this.sampleData)
      .checkToken()
      .commonDispose()
  }

  @action deleteSample = (sampleId) => {
    return request
      .delete(`${config.backend}/pgd/family/${this.familyId}/datas/${sampleId}`)
      .checkToken()
      .commonDispose()
  }

  @action updateSample = (sampleName, remark, sampleId) => {
    return request
      .put(`${config.backend}/pgd/datas/${sampleId}`)
      .send({ sampleName, remark })
      .checkToken()
      .commonDispose()
  }

  @action loadEditHistory = (dataId) => {
    return request
      .get(`${config.backend}/pgd/datas/${dataId}/history`)
      .checkToken()
      .commonDispose()
      .then((res) => (this.editHistoryList = res))
  }

  @action clearEditHistory = () => {
    this.editHistoryList = []
  }

  @action runTask = () => {
    return request
      .post(
        `${config.backend}/pgd/family/${this.familyId}/tasks?appId=${this.familyInfo.appId}`
      )
      .send(this.selectedRowKeys.slice())
      .checkToken()
      .commonDispose()
  }

  @action clearState = () => { }

  @action updateRemarks = (record, remark) => {
    return request
      .put(`${config.backend}/pgd/family/${this.familyId}/tasks/${record.id}`)
      .send({ remark })
      .checkToken()
      .commonDispose()
  }
  
  @action onTraninfoChange = (sample, field, value, that) => {
    sample[field] = value
    if(field==='type'){
      sample['name'] = ''
      sample['breakpoint'] = ''
      sample['chromosome'] = ''
      sample['startPosition'] = ''
      sample['endPosition'] = ''
      sample['chromosome2'] = ''
    }
    this.edited = true
    that && that.forceUpdate()
  }

  @action handleTraninfoObj = (traninfo, type) => {
    switch (type) {
      case 'trans':
        const tran_arr = this.structureMut.filter(tran => tran.type === 'trans')
        tran_arr.forEach((tran, idx) => tran.name = 'tran' + (idx + 1))
        break
      case 'inv':
        const inv_arr = this.structureMut.filter(tran => tran.type === 'inv')
        inv_arr.forEach((inv, idx) => inv.name = 'inv' + (idx + 1))
        break
      default:
    }
  }
  @action delRangeOnTraninfoChange = (sample, field, value, that) => {
    sample[field] = value
    if(field==='gender'){
      sample['chromosome'] = ''
      sample['startPosition'] = ''
      sample['endPosition'] = ''
    }
    this.edited = true
    that && that.forceUpdate()
  }

  @action setEdited = () => {
    this.edited = true
  }

  /**
   * 由后端提供支持
   */
  @action parseCSV = (csvText) => {
    return request
      .put(`${config.backend}/pgd/family/${this.familyId}/datas/csv`)
      .checkToken()
      .send({ context: csvText })
      .commonDispose()
      .then((result) => {
        // result.forEach(this.processData)
        this.sampleData = result
        this.completeRelations() // 加颜色
        this.updateRelationStatus()
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/pgd/dataManageDetail.js